import { SkuField } from '@emi/shared/models';

export const SkuSearchFields: SkuField[] = [
    'Name',
    'GlobalItemIds',
    'EnglishName',
    'PricingStats',
    'Country',
    'EmiImageUrl',
    'Brand',
    'SubBrand',
    'Supplier',
    'Category',
    'AttributeGroups',
    'Measures',
    'Retailer',
    'Description',
    'Ingredients',
    'TotalSkuSize',
];
